export function AdminCover() {
    return(
        <>
            준비중입니다.
        </>
    )
}